import { call, put, takeLatest } from "redux-saga/effects";
import { toast } from "react-toastify";
import * as actionTypes from "../ActionTypes";
import {
  saveGiveSettingSuccess,
  saveGiveSettingFailure,
  updateGiveSettingSuccess,
  updateGiveSettingFailure,
  deleteGiveSettingSuccess,
  deleteGiveSettingFailure,
} from "./giveSettingActions";
import { saveGiveSetting, updateGiveSetting, deleteGiveSetting } from "./giveSettingAPI";

// ✅ Save Give Setting
function* saveGiveSettingSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload;
    const res = yield call(saveGiveSetting, apiPayloadRequest);

    if (res?.type === 1) {
      yield put(saveGiveSettingSuccess(res.data));
      toast.success(res.message || "Give Setting saved successfully!");
      if (action.callback) action.callback({ type: 1, data: res.data });
    } else {
      throw new Error(res?.error || "Save failed");
    }
  } catch (error) {
    yield put(saveGiveSettingFailure(error.message));
    toast.error(error.message);
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}

// ✅ Update Give Setting
function* updateGiveSettingSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload;
    const res = yield call(updateGiveSetting, apiPayloadRequest);

    if (res?.type === 1) {
      yield put(updateGiveSettingSuccess(res.data));
      toast.success(res.message || "Give Setting updated successfully!");
      if (action.callback) action.callback({ type: 1, data: res.data });
    } else {
      throw new Error(res?.error || "Update failed");
    }
  } catch (error) {
    yield put(updateGiveSettingFailure(error.message));
    toast.error(error.message);
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}

// ✅ Delete Give Setting
function* deleteGiveSettingSaga(action) {
  try {
    const { _id, giveObjId } = action.payload;
    const res = yield call(deleteGiveSetting, { _id, giveObjId });

    if (res?.type === 1) {
      yield put(deleteGiveSettingSuccess({ giveObjId }));
      toast.success(res.message || "Give Setting deleted successfully!");
      if (action.callback) action.callback({ type: 1, giveObjId, message: res.message });
    } else {
      throw new Error(res?.error || "Delete failed");
    }
  } catch (error) {
    yield put(deleteGiveSettingFailure(error.message));
    toast.error(error.message);
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}

// ✅ Watcher
export default function* giveSettingWatcherSaga() {
  yield takeLatest(actionTypes.SAVE_GIVESETTING_REQUEST, saveGiveSettingSaga);
  yield takeLatest(actionTypes.UPDATE_GIVESETTING_REQUEST, updateGiveSettingSaga);
  yield takeLatest(actionTypes.DELETE_GIVESETTING_REQUEST, deleteGiveSettingSaga);
}
